import * as fromDatatype from '../datatype-library/index';
// later should be renamed to -> bl_ppl_from_peppol_doc_hdr_queue
export interface bl_ppl_from_peppol_doc_hdr_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
	peppol_sender_id: fromDatatype.VarcharDatatypeInterface;
	peppol_receiver_id: fromDatatype.VarcharDatatypeInterface;
	peppol_organization_id: fromDatatype.VarcharDatatypeInterface;
	peppol_document_creation_datetime: fromDatatype.TimestampTzDatatypeInterface;
	peppol_document_type_id: fromDatatype.VarcharDatatypeInterface;
	peppol_process_id: fromDatatype.TextDatatypeInterface;
	peppol_payload_id: fromDatatype.VarcharDatatypeInterface;
	peppol_current_dt_utc: fromDatatype.TimestampTzDatatypeInterface;
	peppol_lookup_results_status: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_endpoint_url: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_certificate: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_duration: fromDatatype.NumericDatatypeInterface;
	peppol_app_domain: fromDatatype.VarcharDatatypeInterface;
	peppol_app_mode: fromDatatype.VarcharDatatypeInterface;
	peppol_document_xml: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ppl_from_peppol_doc_hdr_history_RowClass
  implements bl_ppl_from_peppol_doc_hdr_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
	peppol_sender_id: fromDatatype.VarcharDatatypeInterface;
	peppol_receiver_id: fromDatatype.VarcharDatatypeInterface;
	peppol_organization_id: fromDatatype.VarcharDatatypeInterface;
	peppol_document_creation_datetime: fromDatatype.TimestampTzDatatypeInterface;
	peppol_document_type_id: fromDatatype.VarcharDatatypeInterface;
	peppol_process_id: fromDatatype.TextDatatypeInterface;
	peppol_payload_id: fromDatatype.VarcharDatatypeInterface;
	peppol_current_dt_utc: fromDatatype.TimestampTzDatatypeInterface;
	peppol_lookup_results_status: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_endpoint_url: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_certificate: fromDatatype.VarcharDatatypeInterface;
	peppol_lookup_results_duration: fromDatatype.NumericDatatypeInterface;
	peppol_app_domain: fromDatatype.VarcharDatatypeInterface;
	peppol_app_mode: fromDatatype.VarcharDatatypeInterface;
	peppol_document_xml: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}
